// extracted by mini-css-extract-plugin
export default {"sizeMD":"16px","Basa":"#EAEBEC","NewGrey":"#596067","attributesLineHeight":"1.8","ScreenLGMin":"(min-width: 1200px)","attributes":"Gbf886f"};